jQuery(function ($) {
    if ($(".property-content").length) {
        $(".property-content .flex-row:contains('Availability')").addClass("row-availability");
        $(".property-content .flex-row:contains('Price')").addClass("row-price");
        $(".property-content .flex-row:contains('Status')").addClass("row-status");
        $(".property-content .flex-row:contains('Status'):contains('Active')").addClass("row-status-active");

        $(".property-content .flex-row:contains('property type:')").find("br").each(function () {
            // Replace each <br> with ", "
            $(this).replaceWith(", ");
        });

        $(".property-content .tabset label:contains('Overview')").addClass("tab tab-overview");
        $(".property-content .tabset label:contains('Details')").addClass("tab tab-details");
        $(".property-content .tabset label:contains('Documents')").addClass("tab tab-documents");
        $(".property-content .tabset label:contains('Map')").addClass("tab tab-map");
        $(".property-content .tabset label:contains('Video')").addClass("tab tab-video");
    }

    if ($(".rn-items-container").length || $(".rn.widget").length || $(".card.nex-item").length) {
        $(".type:contains('FOR SALE')").addClass("type-sale");
        $(".type:contains('for sale')").addClass("type-sale");
        $(".type:contains('FOR LEASE')").addClass("type-lease");
        $(".type:contains('for lease')").addClass("type-lease");
    }

    if ($(".broker-card").length) {
        $(".broker-card").each(function() {
            var agentName = $(this).find("span.font-bold.text-base:first-child");
            console.log($(agentName).text());
            var words = $(agentName).text().split(' ');
            for (var i = 0; i < words.length; i++) {
                words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
            }
            $(agentName).text(words.join(' '));
        });
    }

    if ($(".rn.offices").length) {
        $(".rn.offices .tabset label:contains('Related Agents')").addClass("tab tab-agents");
        $(".rn.offices .tabset label:contains('Featured Listings')").addClass("tab tab-listings");
    }

    if ($(".property-card").length) {
        $(".top-block span:contains('FOR SALE')").addClass("type type-sale");
        $(".top-block span:contains('FOR LEASE')").addClass("type type-lease");
    }
    
	if ($(".properties-grid > .group").length) {
        $(".properties-grid > .group > div > span:contains('FOR SALE')").addClass("type type-sale");
        $(".properties-grid > .group > div > span:contains('FOR LEASE')").addClass("type type-lease");
    }

	$(document).ready(function(){
		if ($('#hiddenFilters').length){				
			var temp = '<div class="rn-primary-action-close" id="rn-advanced-filters-close-btn" style="border: 1px solid var(--awb-color2);border-radius:1rem;height: 2rem;/*! top: -3rem; */width: 2rem;" onclick="jQuery(\'#hiddenFilters\').addClass(\'hidden\')";><svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13M13 13L1 1" stroke="#202022" stroke-width="2" stroke-linecap="round"></path></svg></div>';
			$( "#hiddenFilters" ).prepend( temp );
		}
	});

});
